import types from 'redux/types';

const login = (email, password) => {
  return {
    type: types.REQUEST_API_LOGIN,
    data: {
      email,
      password,
    },
  };
};

const logout = (data) => {
  return {
    ...data,
    type: types.REQUEST_API_LOGOUT,
  };
};

export default {
  login,
  logout,
};
